import React from 'react';
import { Document } from '@react-pdf/renderer';
import AssessmentContent from './assessment_content';

export const AssessmentDocument = ({
  inspection,
  workspace,
  actionItems,
  notes,
  props,
}) => {
  const company = inspection?.creator?.company;

  return (
    <Document>
      <AssessmentContent
        company={company}
        workspace={workspace}
        inspection={inspection}
        notes={notes}
        actionItems={actionItems}
        supplementary={false}
        props={props}
      />
    </Document>
  );
};
